// window.SiteReady(($) => {
window.MapsReady(($) => {

  console.log('Init Block: Event Map');

  let URLParams = new URLSearchParams(window.location.search);

  let statesCities = [];
  let statesCommunities = [];

  var emptyBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(24.396308, -124.848974), // South West
    new google.maps.LatLng(49.384358, -66.885444) // North East
  );

  function initMarker($marker, data) {
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let id = $marker.data('id');
    let state = $marker.data('state');
    let city = $marker.data('city');
    let community = $marker.data('community');
    let community_name = $marker.data('community-name');

    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    let marker = new google.maps.Marker({
      id: id,
      position: latLng,
      map: data.map,
      icon: window.THEME_MAP_MARKER,
      $marker: $marker,
      state: state,
      city: city,
      community_id: community,
      community_name: community_name,
    });

    data.markers.push(marker);

    //

    let content = $marker.html();

    if (content) {
      let infowindow = new google.maps.InfoWindow({
        content: '<div class="event_map_infowindow">' + content + '</div>',
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (data.infoWindow) {
          data.infoWindow.close();
        }

        if (data.activeMarker) {
          data.activeMarker.setIcon(window.THEME_MAP_MARKER);
          data.activeMarker.setZIndex(1);
        }

        infowindow.open(data.map, marker);
        data.infoWindow = infowindow;
        data.activeMarker = marker;

        data.activeMarker.setIcon(window.THEME_MAP_MARKER_ACTIVE);
        data.activeMarker.setZIndex(999);
      });
    }
  }

  function updateResults(data) {
    if (data.infoWindow) {
      data.infoWindow.close();
    }

    if (data.activeMarker) {
      data.activeMarker.setIcon( window.THEME_MAP_MARKER );
    }

    data.visible = [];
    data.markers.forEach((marker, index) => {
      marker.show = true;

      if (data.selectedState) {
        if (marker.state.indexOf(data.selectedState) < 0) {
          marker.show = false;
        }
      }

      if (data.selectedCity) {
        if (marker.city.indexOf(data.selectedCity) < 0) {
          marker.show = false;
        }
      }

      if (marker.show) {
        data.visible.push(marker);
      }
    });

    data.visible.sort((a, b) => {
      return a.dist - b.dist;
    });

    if (data.visible.length == 0) {
      console.log('Event Map: No results');
    }

    //

    let filteredByState = data.markers.filter((item, index, array) => {
      if (
        (data.selectedState && data.selectedState == item.state)
      ) {
        return true;
      }
      return false;
    });

    let filteredCommunities = data.markers.filter((item, index, array) => {
      if (
        (data.selectedState && data.selectedState == item.state) &&
        (!data.selectedCity || data.selectedCity == item.city)
      ) {
        return true;
      }
      return false;
    });

    let filteredCities = filteredByState.map((item) => {
      return item.city;
    }).filter((item, index, array) => {
      return array.indexOf(item) === index;
    });

    let citiesHTML = '';
    let communitiesHTML = '';

    filteredCities.forEach((item) => {
      let selected = (item == data.selectedCity) ? ' selected="selected"' : '';
      citiesHTML += `<option value="${item}"${selected}>${item}</option>`;
    });

    filteredCommunities.forEach((item) => {
      let selected = (item.community_id == data.selectedCommunity) ? ' selected="selected"' : '';
      communitiesHTML += `<option value="${item.community_id}"${selected}>${item.community_name}</option>`;
    });

    data.$cities.attr('disabled', (citiesHTML == '') ? 'disabled' : false);
    data.$cities.html(`<option value="">All Cities</option>` + citiesHTML);

    data.$communities.attr('disabled', (communitiesHTML == '') ? 'disabled' : false);
    data.$communities.html(`<option value="">All Communities</option>` + communitiesHTML);

    //

    let params = Object.fromEntries(URLParams);

    params.state = data.$states.val();
    params.city = data.$cities.val();
    params.community = data.$communities.val();

    window.history.replaceState({}, '', window.location.pathname + '?' + $.param(params));

    centerMap(data);
  }

  function centerMap(data) {
    let bounds = new google.maps.LatLngBounds();
    let markers = data.visible;

    data.markers.forEach((marker) => {
      marker.setVisible(false);
    });

    markers.forEach((marker) => {
      marker.setVisible(true);

      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (data.visible.length == 0) {
      bounds = emptyBounds;
    }

    if (data.visible.length == 1) {
      data.map.setCenter(bounds.getCenter());
    } else {
      data.map.fitBounds(bounds);
    }
  }

  //

  function onItemClick(e, data) {
    console.log('Event Map: Item Click');

    let $target = $(e.currentTarget).parents('.js-map_marker');
    let id = $target.data('id');

    data.markers.forEach((marker) => {
      if (id == marker.id) {
        new google.maps.event.trigger(marker, 'click');
      }
    });
  }

  //

  function onStateSelect(data) {
    console.log('Event Map: Select State');

    let state = data.$states.val();

    if (state !== data.selectedState) {
      data.selectedCity = null;
      data.selectedCommunity = null;
    }

    data.selectedState = state;

    updateResults(data);
  }

  function onCitySelect(data) {
    console.log('Event Map: Select City');

    let city = data.$cities.val();

    if (city !== data.selectedCity) {
      data.selectedCommunity = null;
    }

    data.selectedCity = city;

    updateResults(data);
  }

  function onCommunitySelect(data) {
    console.log('Event Map: Select Community');

    data.selectedCommunity = data.$communities.val();

    updateResults(data);

    data.markers.forEach((marker) => {
      if (data.selectedCommunity == marker.community_id) {
        new google.maps.event.trigger(marker, 'click');
      }
    });
  }

  //

  function init($el) {
    let data = {
      $el: $el,
      $map: $el.find('.js-event_map_el'),
      $markers: $el.find('.js-map_marker').detach(),
      $controls: $el.find('.js-event_map_controls'),
      $states: $el.find('.js-state_select'),
      $cities: $el.find('.js-city_select'),
      $communities: $el.find('.js-community_select'),
      markers: [],
      infoWindow: null,
      activeMarker: null,
      selectedState: null,
      selectedCity: null,
      selectedCommunity: null,
    };

    //

    let mapOptions = {
      zoom: $el.data('zoom') || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      // disableDefaultUI: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: window.THEME_MAP_STYLES,
    };

    data.map = new google.maps.Map(data.$map[0], mapOptions);

    if (URLParams.get('state')) {
      data.$states.val(URLParams.get('state')).change();
      data.selectedState = data.$states.val();
    }

    if (URLParams.get('city')) {
      data.selectedCity = URLParams.get('city');
    }

    if (URLParams.get('community')) {
      data.selectedCommunity = URLParams.get('community');
    }

    //

    data.$markers.each((index, el) => {
      initMarker($(el), data);
    });

    data.visible = data.markers.slice();

    statesCities.sort();
    statesCommunities.sort();

    data.$el.on('click', '.js-map_view_item', (e) => {
      onItemClick(e, data);
    });

    data.$controls.on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    data.$states.on('change', (e) => {
      onStateSelect(data);
    });

    data.$cities.on('change', (e) => {
      onCitySelect(data);
    });

    data.$communities.on('change', (e) => {
      onCommunitySelect(data);
    });

    updateResults(data);

    centerMap(data);

    return data;
  }

  //

  $('.js-event_map').each((index, el) => {
    let map = init($(el));
  });

});